<template>
	<div class="wrap">
		<myHead></myHead>
		<div class="wrap_body" v-loading="is_loading" @mouseover="bindSubCateOut()">
			<div class="center">
				<div class="home_main">
					<div class="search_wrap">
						<div class="search_box">
							<el-dropdown class="type" trigger="click" @command="typeCommand">
								  <span class="el-dropdown-link">
								    {{searchParams.name_type==1?'供应商':'宝贝'}}<i class="el-icon-arrow-down el-icon--right"></i>
								  </span>
								  <el-dropdown-menu slot="dropdown">
								    <el-dropdown-item command="0">宝贝</el-dropdown-item>
								    <!-- <el-dropdown-item command="1">供应商</el-dropdown-item> -->
								  </el-dropdown-menu>
							</el-dropdown>
							<input class="in" placeholder="输入关键字搜索商品" v-model="searchParams.name" @keyup.enter="refresh()"/>
							<!-- <i class="iconfont icon-xiangji" @click.stop="gotoSearch()"></i> -->
						</div>
						<button class="search_btn" @click.stop="refresh()">搜索</button>
						<button class="gongxu_btn" @click="$router.push('./communicate')">信息发布</button>
					</div>
					<div class="top_section"  @mouseover.stop="bindEventStop()" @mouseout.stop="bindEventStop()">
						<div class="shop_cate_wrap">
							<p class="title"><i class="iconfont icon-fenlei2"></i>聚合货源</p>
							<!-- <div class="shop_cate_box">
								<div v-for="(cate,index) in cate_list" class="shop_cate_item" :class="(searchParams.supplier_type==1&&searchParams.cate_shop_id==cate.id)?'active':''" @click="bindShopCate(1,cate.id)">
									{{cate.label}}
								</div>
							</div> -->
							<div class="left_type">
								<div class="type_show">
									<div v-for="(cate,index) in cateGroupList" class="type_line" :class="cate.group_id==currGroupId?'hover':''" @mouseover.stop="bindCateGroupOver(cate,index)">
										<i class="iconfont icon-qunzi"></i>
										<div class="con">
											<span :class="(searchParams.al_cate_1&&searchParams.al_cate_1==nn.categoryID)?'active':''" @click="bindAliCateTap(nn.categoryID,0)" v-for="(nn,nindex) in cate.group_names" :key="nn.cate_id+'_'+nindex">
												{{nn.name}}
											</span>
										</div>
									</div>
								</div>
								<div :class="is_show_cate?'detail_hide active':'detail_hide'"  >
									<div class="detail_label">
										<p class="lv1"></p>
										<div class="label_line" v-for="(cate,index) in subCateList">
											<p class="tab_lv2"><span class="lv2" :class="(searchParams.al_cate_1&&searchParams.al_cate_1==cate.categoryID)?'active':''" @click.stop="bindAliCateTap(cate.categoryID,0)">{{cate.name}}</span></p>
											<div class="tabs_wrap">
												<p class="tab_lv3" :class="(searchParams.al_cate_2&&searchParams.al_cate_2==subCate.categoryID)?'active':''" v-for="(subCate,subIndex) in cate.children" @click.stop="bindAliCateTap(cate.categoryID,subCate.categoryID)">{{subCate.name}}</p>
											</div>
										</div>
							
									</div>
								</div>
							</div>
							<!-- <p class="title"><i class="iconfont icon-fenlei2"></i>线下货源</p> -->
							<div class="shop_cate_box">
								<div v-for="(cate,index) in cate_list2" class="shop_cate_item" :class="(searchParams.supplier_type==2&&searchParams.cate_shop_id==cate.id)?'active':''" @click="bindShopCate(2,cate.id,cate.visible)">
									{{cate.label}}
								</div>
							</div>
						</div>
						
						<div class="center_main">
							<!-- <div class="swiper_wrap">
								<div class="swiper">
									<ul class="swiper-wrapper">
										<li class="swiper-slide">
											<a href="#" class="db"><img src="../../assets/images/banner.png" /></a>
										</li>
										<li class="swiper-slide">
											<a href="#" class="db"><img src="../../assets/images/banner.png" /></a>
										</li>
										<li class="swiper-slide">
											<a href="#" class="db"><img src="../../assets/images/banner.png" /></a>
										</li>
									</ul>
									<div class="swiper_btn prev"><i class="iconfont icon-fanhui"></i></div>
									<div class="swiper_btn next"><i class="iconfont icon-fanhui"></i></div>
								</div>
							</div>
							<a class="adx_box"><img src="../../assets/images/adx.png" /></a> -->
							<div class="swiper_wrap">
								<div class="swiper">
									<ul class="swiper-wrapper">
										<li class="swiper-slide" v-for="(item,index) in bannerList" :key="index">
											<a :href="item.url" class="db"><img :src="item.pic" /></a>
										</li>
									</ul>
									<div class="swiper_btn prev"><i class="iconfont icon-fanhui"></i></div>
									<div class="swiper_btn next"><i class="iconfont icon-fanhui"></i></div>
								</div>
							</div>
							<a class="adx_box" :href="advertData.url"><img style="object-fit: cover;" :src="advertData.pic" /></a>
						</div>
						<div class="right_con">
							<el-link class="supplier_login_btn" :underline="false" :href="supplier_url" target="_blank">供应商登录<i class="el-icon-arrow-right"></i></el-link>
							<div class="user_wrap" v-if="userinfo===''">
								<div class="user_con">
									<div class="head_box"><i class="iconfont icon-touxiang"></i></div>
									<div class="con">
										<p class="name">登录账户</p>
									</div>
								</div>
								<div class="btn_wrap">
									<p class="btn" @click.self="openLoginMask()">登录</p>
									<p class="btn" @click.self="openRegisterMask();">免费注册</p>
								</div>
							</div>
							<div class="user_wrap" v-else>
								<div class="user_con">
									<div class="head_box"><img class="head" :src="avatar"></div>
									<div class="con">
										<p class="name">Hi，{{userinfo.nickname || userinfo.name}}</p>
										<p class="txt">欢迎来到星好货</p>
									</div>
								</div>
								<div class="btn_wrap" v-if="ucmenu.length>0">
									<p class="btn" @click="$router.push(ucmenu[0].url+'?menuId='+ucmenu[0].menu_id)">{{ucmenu[0].title}}</p>
									<p class="btn" @click.self="outLogin()">退出登录</p>
								</div>
							</div>
							<div class="order_nums">
								<div class="num_box" @click="$router.push('./uc_order?status=100')">
									<p class="num">{{(orderCounts&&orderCounts.arr_pdd_status)?orderCounts.arr_pdd_status[0].num:0}}</p>
									<p class="txt">待采购</p>
								</div>
								<div class="num_box" @click="$router.push('./uc_order?status=120')">
									<p class="num">{{(orderCounts&&orderCounts.arr_pdd_status)?orderCounts.arr_pdd_status[2].num:0}}</p>
									<p class="txt">待发货</p>
								</div>
								<div class="num_box" @click="$router.push('./uc_order?status=130')">
									<p class="num">{{(orderCounts&&orderCounts.arr_pdd_status)?orderCounts.arr_pdd_status[3].num:0}}</p>
									<p class="txt">待收货</p>
								</div>
								<div class="num_box" @click="$router.push('./uc_order?status=140')">
									<p class="num">{{(orderCounts&&orderCounts.arr_pdd_status)?orderCounts.arr_pdd_status[4].num:0}}</p>
									<p class="txt">售后</p>
								</div>
<!--								<div class="num_box" @click="$router.push('./uc_order?status=1')">-->
<!--									<p class="num">{{orderCounts.no_pay}}</p>-->
<!--									<p class="txt">待付款</p>-->
<!--								</div>-->
<!--								<div class="num_box" @click="$router.push('./uc_order?status=2')">-->
<!--									<p class="num">{{orderCounts.carry}}</p>-->
<!--									<p class="txt">待发货</p>-->
<!--								</div>-->
<!--								<div class="num_box" @click="$router.push('./uc_order?status=3')">-->
<!--									<p class="num">{{orderCounts.deliver}}</p>-->
<!--									<p class="txt">待收货</p>-->
<!--								</div>-->
<!--								<div class="num_box" @click="$router.push('./uc_order?after_sale=1')">-->
<!--									<p class="num">{{orderCounts.after_sales}}</p>-->
<!--									<p class="txt">售后</p>-->
<!--								</div>-->
							</div>
							<div class="news_wrap">
								<!-- <div class="jiaoliu" @click="$router.push('./communicate')">
									<img src="../../assets/images/jiaoliu.png" alt="">
									<span class="text">交流平台</span>
								</div> -->
								<img class="news_img" src="../../assets/images/news.png" />
								<p class="news_link" @click="$router.push('./notice?type=1&id='+item.id)" v-for="(item,index) in newsList" :key="index">
									<span class="title">{{item.title}}</span><span class="time">{{item.updatetime}}</span>
								</p>
							</div>
						</div>
					</div>
					<div class="product_section" >
						<div class="screen_wrap">
							<p class="title">为你推荐</p>

							<el-dropdown v-if="false" class="tab" :class="searchParams.shichang_name?'active':''" trigger="click" @command="supplierCommand">
								<span class="el-dropdown-link">
									{{!searchParams.shichang_name?'选择市场':searchParams.shichang_name}}<i class="el-icon-arrow-down el-icon--right"></i>
								</span>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item command="">默认</el-dropdown-item>
									<el-dropdown-item :command="item.shichang_name" v-for="(item,index) in shichangList" :key="item.shichang_name">{{item.shichang_name}}</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
							<p class="tab" :class="searchParams.time_sort==1?'active':''" @click="searchTap('time_sort',1)">上新时间</p>
							<p class="tab" v-if="false" :class="searchParams.sales_sort==1?'active':''" @click="searchTap('sales_sort',1)">全网销量</p>
							<p class="tab" :class="searchParams.sales_sort==2?'active':''" @click="searchTap('sales_sort',2)">销量</p>
							<p class="tab" v-if="false" :class="searchParams.free_express==1?'active':''" @click="searchTap('free_express',1)">包邮</p>
							<el-dropdown class="tab" :class="searchParams.price_sort>0?'active':''" trigger="click" @command="priceCommand">
								<span class="el-dropdown-link">
									{{searchParams.price_sort==1?'价格从高到低':searchParams.price_sort==2?'价格从低到高':'价格'}}<i class="el-icon-arrow-down el-icon--right"></i>
								</span>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item command="0">默认</el-dropdown-item>
									<el-dropdown-item command="1">价格从高到低</el-dropdown-item>
									<el-dropdown-item command="2">价格从低到高</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
							<p class="in_box">￥<input class="in" v-model="searchParams.min_price"/></p>
							<p class="in_line">-</p>
							<p class="in_box">￥<input class="in" v-model="searchParams.max_price"/></p>
							<p class="in_btn" @click="refresh()">确定</p>
							<p class="in_btn" @click="reset()">清空</p>
							<p class="in_btn" @click="selectAll()">全选</p>
							<p class="in_btn" @click="allPuhuo()">一键铺货</p>
						</div>
						<productList :listData="list" :loading="product_loading" ref="products"></productList>

						<div class="turn_page">
							<Pagination :total="page_data.total" :page.sync="page_data.page" :limit.sync="page_data.limit" @pagination="getProduct" layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10,20,50,100]" />
						</div>

					</div>
				</div>
				<!-- <el-dialog class="login_mask" :visible.sync="is_login" width="346px" @close="closeMask">
					<div class="login_main">
						<div class="login_type" v-show="login_type!=3">
							<p :class="login_type==1?'tab active':'tab'" @click="codeLoginClick">扫码登录</p>
							<p :class="login_type==2?'tab active':'tab'" @click="accountLoginClick">账户登录</p>
						</div>
						<div class="code_login" v-show="login_type==1" v-loading="loadingCode">
							<img class="code" :src="imageCode" />
							<p class="txt">打开手机微信，扫描二维码</p>
						</div>
						<div class="account_login" v-show="login_type==2">
							<div v-if="!is_code_login">
								<el-input v-model="login_phone" placeholder="手机号登录" class="el_input">
									<p class="icons" slot="prefix"><i class="iconfont icon-yonghu"></i></p>
								</el-input>
								<el-input v-model="login_pwd" placeholder="密码" class="el_input" type="password">
									<p class="icons" slot="prefix"><i class="iconfont icon-clock"></i></p>
								</el-input>
							</div>
							<div v-else>
								<el-input v-model="login_phone" placeholder="输入手机号" class="el_input el_in2">
									<p slot="prefix" class="txts">手机号码</p>
								</el-input>
                <el-input v-model="reg_captcha" placeholder="请输入验证码" class="el_input el_in2">
                  <p slot="prefix" class="txts">验证码</p>
                </el-input>
                <div class="mt-4">
                  <img class="w-40" :src="captcha_url" @click="refreshCaptcha" />
                </div>
								<el-input v-model="login_code" placeholder="短信验证码" class="el_input el_in2">
									<p slot="prefix" class="txts">验证码</p>
									<p slot="suffix" class="getcode" @click="getPhoneCode('2')">{{is_get_phone_code?phone_second+'s重新获取':'获取验证码'}}</p>
								</el-input>
							</div>
							<p class="change_way">
								<el-checkbox v-model="remember_pwd">记住密码</el-checkbox>
								<span @click="is_code_login=!is_code_login;refreshCaptcha();">
									{{is_code_login?'账号密码登录':'验证码登录'}}
								</span>
							</p>
							<p class="login_btn" @click="loginSubmit">登录</p>
						</div>
						<div class="code_login" v-show="login_type==3" v-loading="loadingCode">
							<img class="code" :src="imageCode" />
							<p class="txt">扫码关注公众号并绑定手机号</p>
						</div>
						<p class="go_register">还没账户？<a @click="is_register=true;is_login=false;reg_step=1;refreshCaptcha()">去注册</a></p>
					</div>
				</el-dialog>
				<el-dialog class="register_mask" title="注册账号" :visible.sync="is_register" width="346px">
					<div class="register_main">
						<div class="step1" v-if="reg_step==1">
							<el-input v-model="yqm" disabled class="el_input el_in2" v-if="yqm">
								<p slot="prefix" class="txts">邀请码</p>
							</el-input>
							<el-input v-model="reg_phone" placeholder="输入手机号" class="el_input el_in2">
								<p slot="prefix" class="txts">手机号码</p>
							</el-input>
              <el-input v-model="reg_captcha" placeholder="请输入图形验证码" class="el_input el_in2">
                <p slot="prefix" class="txts">验证码</p>
              </el-input>
              <div class="mt-4">
                <img class="w-40" :src="captcha_url" @click="refreshCaptcha" />
              </div>
							<el-input v-model="reg_code" placeholder="短信验证码" class="el_input el_in2">
								<p slot="prefix" class="txts">验证码</p>
								<p slot="suffix" class="getcode" @click="getPhoneCode('1')">{{is_get_phone_code?phone_second+'s重新获取':'获取验证码'}}</p>
							</el-input>
							<el-input v-model="reg_pwd" type="password" placeholder="输入密码" class="el_input el_in2">
								<p slot="prefix" class="txts">设置密码</p>
							</el-input>
							<el-input v-model="reg_pwd_confirm" type="password" placeholder="再次输入密码" class="el_input el_in2">
								<p slot="prefix" class="txts">确认密码</p>
							</el-input>
							<p class="register_btn" @click="regSubmit">注册</p>
							<div class="check_line">
								<label class="la"><el-checkbox v-model="reg_checked"></el-checkbox>我已同意并阅读</label>
								<p class="link" @click="$router.push('./notice?type=4&id=3')">《星好货用户协议》</p>
							</div>
						</div>
						<div class="step2" v-if="reg_step==2" v-loading="loadingCode">
							<p class="title" style="padding-bottom: 50px;">扫码关注公众号</p>
							<img class="code" :src="imageCode" />
							<p class="code_txt">打开手机微信，扫描二维码</p>
						</div>
					</div>
				</el-dialog> -->
			</div>
		</div>
		<shopList ref="child"></shopList>
		<myFoot :showBeian="true"></myFoot>
		<loginRegister ref="loginRegister" @refresh="loginRefresh()"></loginRegister>
	</div>
</template>

<script>
import "swiper/swiper-bundle.min.css";
import { mapActions,mapState,mapMutations } from "vuex";
import Swiper, { Navigation, Autoplay } from "swiper";
import myHead from '../../components/myHead/myhead';
import myFoot from '../../components/myFoot/myfoot';
import productList from '../../components/productList/productlist';
import shopList from '../../components/shopList/shopList';
import loginRegister from '../../components/loginRegister/loginRegister';
import common from '../../assets/js/utils/common';
import headDefault from '../../assets/images/head.png';
import Pagination from '../../components/pagination/pagination';
import config from "../../assets/js/conf/config";

export default {
	name: "index",
	data(){
		return{
			headDefault,
			input1:'',
			input2:'',
			is_show_cate:false,
			is_sub_cate_hover: false,


			cate_list: [],
			cate_list2: [],
			// is_login:false,
			// is_register:false,
			// login_type:1,
			// reg_step:1,
			list:[],
			// is_code_login:false,
			// reg_phone:"",
			// reg_code:"",
			// reg_pwd:"",
			// reg_pwd_confirm:"",
   //    reg_captcha:"",
			// remember_pwd:false,
			// is_get_phone_code:false,
			// is_reg_submit:false,
			// reg_checked:false,
			// phone_second:60,
			// imageCode:"",
			// login_phone:"",
			// login_pwd:"",
			// login_code:"",
			// is_login_submit:false,
			checkBindTimer:null,
			userId:"",
			loadingCode:false,
			userinfo:"",
			avatar:"",
			is_loading: false,
			product_loading:false,
			cateGroupList: [],
			currGroupName: '',
			currGroupId: 0,
			subCateList: [],
			searchParams: {
				supplier_type: 0,//0全部，1多多货源，2线下货源
				cate_shop_id: 0,
			},
			page_data: {
				limit: 20,
				page: 1,
				total:0,
			},
			advertData:"",
			bannerList:[],
			bannerSwiper:null,
			newsList:[],
			orderCounts: {
				no_pay:0,
				carry:0,
				deliver:0,
				after_sales:0
			},
			yqm:"",
			yq_grade:"",
			checkList: [],
			shichangList: [],
      // captcha_url: '',
      supplier_url: config.supplier_url,
		}
	},
	components:{
		myHead,myFoot,productList,Pagination,shopList,loginRegister
	},
	mounted(){
		// this.$nextTick(function () {
		// 	window.addEventListener('scroll', this.onScroll)
		// })
	},
	computed:{
		...mapState({
			users:(state)=>state.login.userinfo,
			avatars:(state)=>state.login.avatar,
			ucmenu:(state)=>state.login.ucmenu,
		}),
	},
	created() {
		this.init()
		this.userinfo = this.users?this.users:""
		this.avatar = this.avatars || headDefault
		var query = this.$route.query
		if(query.reg){
			this.is_register = true
			this.yqm = query.yqm
			this.yq_grade = query.yq_grade
		}
	},
	destroyed() {
		 // window.removeEventListener('scroll', this.onScroll)
	},
	methods:{
		...mapActions({
			doAddAllProduct:"cart/doAddAllProduct",
			doSubmitPH:"cart/doSubmitPH",
			getMallShopCate:"index/getMallShopCate",
			getMallCateData:"index/getMallCateData",
			getMallProductList:"index/getMallProductList",
			getBusinessOrderCount:"index/getBusinessOrderCount",
			getCodeData:"login/getCodeData",
			getQrcodeData:"login/getQrcodeData",
			checkWxBind:"login/checkWxBind",
			DoAccountLogin:"login/DoAccountLogin",
			DoCodeLogin:"login/DoCodeLogin",
			DoRegister:"login/DoRegister",
			getIndexBannerData:"index/getIndexBannerData",
			getAnnouncementData:"index/getAnnouncementData",
			getUcenterMenu:"login/getUcenterMenu",
			getUserinfoData:"ucenter/getUserinfoData",
			opBindProductInviteCode:"ucenter/opBindProductInviteCode",
		}),
		...mapMutations({
			OUT_LOGIN:"login/OUT_LOGIN"
		}),

		allPuhuo(){
			let product_ids = this.$refs.products.select_product_ids
			if(product_ids.length == 0){
				this.$message({message: '请先勾选铺货商品',type: 'warning',});
				return
			}
			this.$refs.child.showShopList()

			// this.doAddAllProduct({data:{product_ids:product_ids},success:(res) => {
			// 	if(res.code == 200){
			// 		this.$message({message: res.msg,type: 'success',});
			// 	}else{
			// 		this.$message({message: res.msg,type: 'error',});
			// 	}
			// }})

		},
		phSubmit(val,freight_template_ids){//立即铺货
			let product_ids = this.$refs.products.select_product_ids
			if(product_ids.length == 0){
				this.$message({message: '请先勾选铺货商品',type: 'warning',});
			}
			let param = {shop_id:val,type:'1',product_id:product_ids,freight_template_ids:freight_template_ids}
			this.doSubmitPH({data:param,success:(res)=>{
				if(res.code===200){
					this.$message({message: res.msg,type: 'success',});
					setTimeout(()=>{
						this.$refs.child.closeShopList()
					},300)
				} else {
					this.$message({message: res.msg,type: 'error',});
				}
			}})
		},
		// codeLoginClick(){
		// 	this.login_type = 1
		// 	setTimeout(()=>{this.loadingCode = true},100)
		// 	this.getLoginCode('',true,'1')
		// },
		// accountLoginClick(){
		// 	this.login_type = 2
		// 	clearTimeout(this.checkBindTimer)
		// },
		init(){
			this.getOrderCount()
			this.getShopCate()
			// this.getCateList()
			this.getProduct()
			this.getAdcertData()
			this.getNewsData()
			this.initUserInfo()
		},
		initUserInfo(){
			this.getUserinfoData({data:{},success:(res)=>{
				if(res.code===200){
					console.log('update userinfo success',res)

				} else {
					this.$message({message: res.msg,type: 'error',});
				}
			}})
		},
		gotoSearch(){
			let param = this.searchParams
			this.$router.push({ name: 'search', query: param})
		},
		bindShopCate(supplier_type,cate_shop_id,visible=1){
			console.log(123,visible)
			if(supplier_type == 2 && visible!=1){
				this.showInputProductInviteCode(cate_shop_id);
				return;
			}
			this.searchParams.supplier_type = supplier_type
			this.searchParams.cate_shop_id = cate_shop_id
			this.searchParams.al_cate_1 = 0
			this.searchParams.al_cate_2 = 0
			this.refresh()
		},

		loginRefresh(){
			this.userinfo = this.users
			this.avatar = this.avatars || headDefault
			this.refresh()
		},
		// getUCmenu(){
		// 	this.getUcenterMenu({data:{},success:(res)=>{
		// 		if(res.status==200){
		// 			console.log('getUCmenu',res)
		// 			// this.employeeData.data = res.data
		// 		} else {
		// 			this.$message({message: res.msg,type: 'error',});
		// 		}
		// 	}})
		// },
		// loginSubmit(){//登录提交
		// 	if(!this.login_phone){
		// 		this.$message({message: '请输入手机号码',type: 'error',});
		// 		return false
		// 	}
		// 	if(!this.is_code_login){//账号密码登录
		// 		if(!this.login_pwd){
		// 			this.$message({message: '请输入密码',type: 'error',});
		// 			return false
		// 		}
		// 		if(!this.is_login_submit){
		// 			this.is_login_submit = true
		// 			this.DoAccountLogin({data:{
		// 					mobile:this.login_phone,
		// 					password:this.login_pwd,
		// 				},success:(res)=>{
		// 				if(res.code===200){
		// 					this.setLoginCookie()
		// 					this.$message({message: res.msg,type: 'success',});
		// 					if(res.data == 'null'){
		// 						window.location.reload()
		// 						return
		// 					}
		// 					this.userinfo = res.data.userinfo
		// 					this.avatar = res.data.userinfo.avatar || headDefault
		// 					this.getUCmenu()
		// 					this.refresh()
		// 					if(res.data.userinfo.is_follow==0){
		// 						this.login_type = 3
		// 						this.getLoginCode(this.login_phone,true)
		// 					}else{
		// 						this.closeMask()
		// 						console.log('sssss')
		// 					}
		// 				} else {
		// 					this.$message({message: res.msg,type: 'error',});
		// 					this.is_login_submit = false
		// 				}
		// 			}})
		// 		}
		// 	}else{//短信验证码登录
		// 		if(!this.login_code){
		// 			this.$message({message: '请获取短信验证码',type: 'error',});
		// 			return false
		// 		}
		// 		if(!this.is_login_submit){
		// 			this.is_login_submit = true
		// 			this.DoCodeLogin({data:{
		// 					mobile:this.login_phone,
		// 					code:this.login_code,
		// 				},success:(res)=>{
		// 				if(res.code===200){
		// 					console.log('code login success',res)
		// 					this.userinfo = res.data.userinfo
		// 					this.avatar = res.data.userinfo.avatar || headDefault
		// 					this.getUCmenu()
		// 					this.refresh()
		// 					this.$message({message: res.msg,type: 'success',});
		// 					if(res.data.userinfo.is_follow==0){
		// 						this.login_type = 3
		// 						this.getLoginCode(this.login_phone,true)
		// 					}else{
		// 						this.closeMask()
		// 					}
		// 				} else {
		// 					this.$message({message: res.msg,type: 'error',});
		// 					this.is_login_submit = false
		// 				}
		// 			}})
		// 		}
		// 	}
		// },
		// regSubmit(){//注册提交
		// 	if(!common._verify_mobile(this.reg_phone)){
		// 		this.$message({message: '请输入正确手机号',type: 'error',});
		// 		return false
		// 	}
		// 	if(!this.reg_code){
		// 		this.$message({message: '请获取短信验证码',type: 'error',});
		// 		return false
		// 	}
		// 	if(!this.reg_pwd){
		// 		this.$message({message: '请输入密码',type: 'error',});
		// 		return false
		// 	}
		// 	if(!this.reg_pwd_confirm){
		// 		this.$message({message: '请再次输入密码',type: 'error',});
		// 		return false
		// 	}
		// 	if(this.reg_pwd != this.reg_pwd_confirm){
		// 		this.$message({message: '请确保两次输入的密码一致',type: 'error',});
		// 		return false
		// 	}
		// 	if(!this.reg_checked){
		// 		this.$message({message: '请阅读并同意用户协议',type: 'error',});
		// 		return false
		// 	}
		// 	if(!this.is_reg_submit){
		// 		this.is_reg_submit = true
		// 		this.DoRegister({data:{
		// 				mobile:this.reg_phone,
		// 				code:this.reg_code,
		// 				password:this.reg_pwd,
		// 				true_password:this.reg_pwd_confirm,
		// 				yqm:this.yqm,
		// 				yq_grade:this.yq_grade,
		// 			},success:(res)=>{
		// 			console.log('register success',res)
		// 			if(res.code===200){
		// 				this.$message({message: '注册成功~',type: 'success',});
		// 				this.reg_step = 2
		// 				this.loadingCode = true
		// 				this.getLoginCode(this.reg_phone,true)
		// 				setTimeout(()=>{
		// 					this.is_reg_submit = false
		// 					this.reg_phone = ''
		// 					this.reg_code = ''
		// 					this.reg_pwd = ''
		// 					this.reg_pwd_confirm = ''
		// 				},1500)
		// 			} else {
		// 				this.$message({message: res.msg,type: 'error',});
		// 				this.is_reg_submit = false
		// 			}
		// 		}})
		// 	}
		// },
		// getPhoneCode(ev){//获取短信验证码
		// 	let phone = this.is_login?this.login_phone:this.reg_phone
		// 	if(!common._verify_mobile(phone)){
		// 		this.$message({message: '请输入正确手机号',type: 'error',});
		// 		return false
		// 	}
  //     if(!this.reg_captcha){
  //       this.$message({message: '请先输入图形验证码',type: 'error',});
  //       return false
  //     }
		// 	if(!this.is_get_phone_code){
		// 		this.is_get_phone_code = true
		// 		this.getCodeData({data:{
		// 				mobile:phone,
		// 				event:ev,
  //           captcha: this.reg_captcha,
		// 			},success:(res)=>{
		// 			if(res.code===200){
		// 				console.log('get phone code',res)
		// 				this.$message({message: '发送成功~',type: 'success',});
		// 				let timer = setInterval(()=>{
		// 					this.phone_second -= 1
		// 					if(this.phone_second == 0){
		// 						clearInterval(timer)
		// 						this.phone_second = 60
		// 						this.is_get_phone_code = false
		// 					}
		// 				},1000)
		// 			} else {
		// 				this.$message({message: res.msg,type: 'error',});
		// 				this.is_get_phone_code = false
		// 			}
		// 		}})
		// 	}

		// },
		// closeMask(){//关闭登录注册弹窗
		// 	this.is_login = false
		// 	this.is_register = false
		// 	this.is_get_phone_code = false
		// 	this.phone_second = 60
		// 	this.reg_step = 1
		// 	clearTimeout(this.checkBindTimer)
		// },
		openLoginMask(){//打开登录弹窗
			this.$refs.loginRegister.openLoginMask()
		},
		openRegisterMask(){
			this.$refs.loginRegister.openRegisterMask()
		},//打开注册弹窗
		// getLoginCode(phone='',isCheck=false,type='2'){//获取登录二维码,type=1表示直接通过二维码扫码登录，不需要传手机号
		// 	this.getQrcodeData({data:{
		// 			mobile:phone,
		// 			level:'2',
		// 			bind_uid:'0',
		// 			type:type,
		// 		},success:(res)=>{
		// 		if(res.code===200){
		// 			console.log('get qr code',res)
		// 			this.imageCode = res.msg.ticket_img
		// 			setTimeout(()=>{this.loadingCode = false},1000)
		// 			if(isCheck){
		// 				this.int_uid = res.msg.int_uid
		// 				this.checkBind(res.msg.int_uid)
		// 			}
		// 		} else {
		// 			this.$message({message: res.msg,type: 'error',});
		// 		}
		// 	}})
		// },
		// checkBind(id){//检测是否微信绑定成功
		// 	this.checkWxBind({data:{
		// 			int_uid:id,
		// 		},success:(res)=>{
		// 		console.log('check login',res)
		// 		if(res.code===200){
		// 			this.userinfo = res.data.userinfo
		// 			this.avatar = res.data.userinfo.avatar || headDefault
		// 			this.getUCmenu()
		// 			this.$message({message: res.msg,type: 'success',});
		// 			this.closeMask()
		// 		} else {
		// 			this.checkBindTimer = setTimeout(()=>{
		// 				this.checkBind(this.int_uid)
		// 			},1500)
		// 		}
		// 	}})
		// },
		outLogin(){//退出登录
			this.$message({message: '已退出登录',type: 'success',});
			this.OUT_LOGIN()
			this.userinfo = ''
			this.is_login_submit = false
			this.login_type = 1
			this.phone_second = 60
			if(!this.remember_pwd){
				this.login_phone = ''
				this.login_pwd = ''
			}
			this.login_code = ''
			this.refresh()
		},
		getAdcertData(){//获取banner及广告
			this.getIndexBannerData({data:{},success:(res) => {
				if(res.code == 200){
					this.advertData = res.data.advert
					this.bannerList = res.data.banners
					this.$nextTick(()=>{
						this.bannerSwiper = new Swiper('.swiper_wrap .swiper', {
							autoplay: {
								delay: 3000,
								stopOnLastSlide: false,
								disableOnInteraction: false,
							},
							modules: [Navigation, Autoplay],
							navigation: {
								nextEl: ".swiper_wrap .swiper_btn.next",
								prevEl: ".swiper_wrap .swiper_btn.prev",
							},
							loop: true,
							observer:true,
							observeParents:true,

						})
					})
				}
			}})
		},
		getNewsData(){//获取公告列表
			this.getAnnouncementData({data:{limit:3,page:1},success:(res) => {
				if(res.code == 200){
					console.log('获取公告列表',res)
					this.newsList = res.data.data
				}
			}})
		},
		//获取商家订单数量
		getOrderCount(){
			this.getBusinessOrderCount({data:{},success:(res) => {
				if(res.code == 200){
					this.orderCounts = res.data.orderCounts
				}else{
					this.orderCounts = {
						no_pay:0,
						carry:0,
						deliver:0,
						after_sales:0
					}
				}
				this.is_loading = false
			}})
		},
		getShopCate(){
			this.is_loading = true
			this.getMallShopCate({data:{},success:(res) => {
				if(res.code == 200){
					this.cate_list = res.data.cate_list
					this.cate_list2 = res.data.cate_list2
					this.cateGroupList = res.data.cate_group
					if(res.data.cate_group.length>0){
						this.subCateList = res.data.cate_group[0].cate_list
					}
				}
				this.is_loading = false
			}})
		},
		//获取商品分类
		getCateList(){
			this.is_loading = true
			this.getMallCateData({data:{},success:(res) => {
				if(res.code == 200 && res.data.lists.length > 0){
					this.cateGroupList = res.data.lists
					this.subCateList = res.data.lists[0].cate_list
					this.shichangList = res.data.shichang_list
				}
				this.is_loading = false
			}})
		},
		selectAll(){
			this.$refs.products.checkAll()
		},
		//获取商品列表
		getProduct(){

			if(this.product_loading) return
			this.product_loading = true
			this.list = []
			let searchParams = this.searchParams
			let param = {limit:this.page_data.limit,page:this.page_data.page,state:this.state}
			Object.assign(param, searchParams)
			// console.log(param)
			this.getMallProductList({data:param,success:(res)=>{
				if(res.code===200){
					// console.log('get goods list',res)
					// if(this.page_data.page == 1){
					// 	this.list = res.data.data
					// }else{
					// 	this.list = this.list.concat(res.data.data)
					// }

					this.list = res.data.data
					this.page_data.total = res.data.total
					if(this.list.length > 10){
						// document.documentElement.scrollTop = 400
					}
				} else {
					this.$message({message: res.msg,type: 'error',});
				}
				this.product_loading = false
				// this.page_data.page ++
			}})
		},
		//滚动加载
		onScroll(){
			// 滚动条到最顶端的距离
			let scrolled = document.documentElement.scrollTop || document.body.scrollTop;
			let clientHeight = document.documentElement.clientHeight
			let scrollHeight = document.documentElement.scrollHeight
			if(scrolled + clientHeight + 400 >= scrollHeight){
				this.loadMore()
			}
		},
		//刷新列表
		refresh(){
			this.page_data.page = 1
			this.getProduct()
			this.getOrderCount()
			this.getShopCate()
		},
		//清空筛选
		reset(){
			this.searchParams = {}
			this.refresh()
		},
		//加载商品
		loadMore(){
			if (this.page_data.total <= this.list.length) {
				return false
			} else{
				this.getProduct()
			}
		},

		searchTap(name,val){
			if(!this.searchParams[name] || this.searchParams[name] != val){
				this.searchParams[name] = val
			}else{
				this.searchParams[name] = 0
			}
			this.refresh()
		},
		typeCommand(val){
			this.searchParams.name_type = val
			this.refresh()
		},
		priceCommand(val){
			this.searchParams.price_sort = val
			this.refresh()
		},
		timeCommand(val){
			this.searchParams.time_sort = val
			this.refresh()
		},
		supplierCommand(val){
			console.log(val)
			this.searchParams.shichang_name = val
			this.refresh()
		},
		bindEventStop(){
			return false;
		},
		bindCateGroupOver(row,index){
			this.subCateList = row.cate_list
			this.currGroupName = row.name
			this.currGroupId = row.group_id
			this.is_show_cate = true
		},
		bindSubCateOut(){
			this.is_show_cate = false
			this.subCateList = []
			this.currGroupName = ''
			this.currGroupId = 0
		},
		bindCateTap(first_cid,second_cid){
			let searchParams = this.searchParams
			searchParams.cate_id = [first_cid,second_cid]
			this.searchParams = searchParams
			this.bindSubCateOut()
			this.refresh()
		},
		bindAliCateTap(al_cate_1,al_cate_2){
			let searchParams = this.searchParams
			if(al_cate_1){
				searchParams.al_cate_1 = al_cate_1
			}else{
				searchParams.al_cate_1 = 0
				searchParams.al_cate_2 = 0
			}
			if(al_cate_2){
				searchParams.al_cate_2 = al_cate_2
			}else{
				searchParams.al_cate_2 = 0
			}
			searchParams.cate_shop_id = 0
			searchParams.supplier_type = 0
			this.searchParams = searchParams
			this.bindSubCateOut()
			this.refresh()
		},
		//绑定特邀渠道分类邀请码
		showInputProductInviteCode(cate_shop_id){
			this.$prompt('此分类为特邀渠道，请输入邀请码', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				inputErrorMessage: '请输入邀请码',
				beforeClose: (action, instance, done) => {
					if (action === 'confirm') {
						instance.confirmButtonLoading = true;
						const value = instance.inputValue
						this.opBindProductInviteCode({data:{cate_shop_id,product_invite_code:value},success:(res)=>{
							instance.confirmButtonLoading = false;
							if(res.code===200){
									this.bindShopCate(2,cate_shop_id,1)
									done()
								} else {
									this.$message({message: res.msg,type: 'error'});
									return false // 阻止关闭
								}
						}})
					} else {
						done()
					}
				},
			});
		},
		//手机登录记住密码
		// setLoginCookie(){
		// 	if(this.remember_pwd && this.login_type == 2){
		// 		var businessLoginData = {remember_pwd:true,login_phone:this.login_phone,login_pwd:this.login_pwd}
		// 		this.$cookies.set('businessLoginData',businessLoginData,'30d')
		// 	}else{
		// 		var businessLoginData = false
		// 		this.$cookies.set('businessLoginData',businessLoginData,'1s')
		// 	}
		// },
    // refreshCaptcha(){
    //   this.captcha_url = config.baseApi + '/business/login/captcha?_t=' + new Date().getTime()
    // },
	}
}
</script>

<style scoped>

.home_main{width: 100%;height: auto;margin-top: 30px;margin-bottom: 40px;}
.search_wrap{margin: 0 auto;display: flex;justify-content: center;font-size: 16px;}
.search_wrap .search_box{width: 900px;height: 50px;box-sizing: border-box;background-color: #ffffff;border-radius: 4px 0vw 0vw 4px;border: solid 2px #fa5757;display: flex;align-items: center;}
.search_wrap .search_box .type{width: 84px;color: #333333;cursor: pointer;text-align: center;line-height: 26px;border-right: 1px solid #ddd;}
.search_wrap .search_box .in{flex: 1;width: 0;margin: 0 15px;color: #333333;font-size: 16px;}
.search_wrap .search_box .icon-xiangji{margin-right: 14px;font-size: 24px;color: #999;cursor: pointer;}
.search_wrap .search_btn{width: 132px;height: 50px;background-image: linear-gradient(180deg, #fa5757 0%, #fb6d6d 100%), linear-gradient(#ffffff, #ffffff);background-blend-mode: normal, normal;border-radius: 0vw 4px 4px 0vw;display: flex;justify-content: center;align-items: center;color: #ffffff;font-weight: bold;cursor: pointer;}

.search_wrap .gongxu_btn{width: 132px;height: 50px;background-image: linear-gradient(180deg, #ffffff 0%, #fbf5f5 100%), linear-gradient(#ffffff, #fbf5f5);background-blend-mode: normal, normal;border-radius: 4px;display: flex;justify-content: center;align-items: center;color: #e4393c;font-weight: bold;cursor: pointer;margin-left: 10px;border: 1px solid #e4393c;}
.top_section{margin-top: 30px;width: 100%;display: flex;justify-content: space-between;}
.top_section .shop_cate_wrap{width: 220px;height: 384px;background-color: #ffffff;box-sizing: border-box;padding-bottom: 12px;padding-top: 24px;position: relative;padding:0 15px;}
.top_section .shop_cate_wrap .title{font-weight: bold;font-size: 14px;line-height: 30px;margin-top: 5px;}
.top_section .shop_cate_wrap .shop_cate_box{width:100%;height: auto;gap: 5px;display:flex;flex-wrap: wrap;}
.top_section .shop_cate_wrap .shop_cate_box .shop_cate_item{white-space: nowrap;cursor: pointer;line-height: 2;font-size: 14px;}
.top_section .shop_cate_wrap .shop_cate_box .shop_cate_item:hover{color: #fa5757;text-decoration: underline;}
.top_section .shop_cate_wrap .shop_cate_box .shop_cate_item.active{color: #fa5757;text-decoration: underline;}
.top_section .left_type{width: 200px;background-color: #ffffff;box-sizing: border-box;position: relative;}
.left_type .type_show{width: 100%;height: 100%;}
.left_type .type_show .title{display: flex;align-items: center;line-height: 1;font-weight: bold;margin-bottom: 10px;padding: 0 20px;}
.left_type .type_show .title .icon-fenlei2{font-size: 16px;margin-right: 8px;}
.left_type .type_show .type_line{width: 220px;min-height: 28px;display: flex;align-items: flex-start;line-height: 28px;box-sizing: border-box;font-size: 14px;transform: translateX(-15px);padding: 0 5px 0 15px;overflow: hidden;}

.left_type .type_show::-webkit-scrollbar{width:5px;height:5px;}
.left_type .type_show::-webkit-scrollbar-track{background: #efefef;}
.left_type .type_show::-webkit-scrollbar-thumb{background: #bfbfbf;}
.left_type .type_show::-webkit-scrollbar-corner{background: #333;}

.left_type .type_show .type_line .iconfont{font-size: 18px;display: none;}
.left_type .type_show .type_line .con{flex: 1;width: 0;display: flex;gap: 5px;}
.left_type .type_show .type_line .con span:hover{color: #fa5757;text-decoration: underline;cursor: pointer;}
.left_type .type_show .type_line .con span.active{color: #fa5757;text-decoration: underline;cursor: pointer;}
.left_type .type_show .type_line .con>em{font-weight: bold;padding: 0 6px;}
.left_type .type_show .type_line .con>em:last-child{display: none;}
.left_type .type_show .type_line:hover{background: #ffedee;}
.left_type .type_show .type_line.hover{background: #ffedee;}
.left_type .detail_hide{width: 980px;height: auto;box-sizing: border-box;position: absolute;top: 0;left: 220px;z-index: 22;background: #fff;box-shadow: 0 0 10px 0 #eeeeee;visibility: hidden;opacity: 0;transition: all .3s ease-in-out;}
.left_type .detail_hide.active{visibility: visible;opacity: 1;margin-top: -41px;}
.detail_hide .detail_label{height: auto;min-height: 300px;box-sizing: border-box;padding: 30px 30px 40px;max-height: calc(100vh - 200px);overflow-y: scroll;}
.detail_hide .detail_label:first-child{margin-top: 0;}
.detail_hide .detail_label .lv1{color: #e4393c;font-weight: bold;line-height: 1;margin-bottom: 6px;font-size: 16px !important;}
.detail_hide .detail_label .label_line{margin-top: 12px;font-size: 12px;line-height: 24px;display: flex;}
.detail_hide .detail_label .label_line .tab_lv2{font-weight: bold;width: 90px;padding-right: 20px;}
.detail_hide .detail_label .label_line .tab_lv2 .lv2{cursor: pointer;}
.detail_hide .detail_label .label_line .tab_lv2 .lv2.active{color: #e4393c;text-decoration: underline;}
.detail_hide .detail_label .label_line .tabs_wrap{flex: 1;width: 0;display: flex;flex-wrap: wrap;}
.detail_hide .detail_label .label_line .tabs_wrap .tab_lv3{margin-right: 15px;cursor: pointer;line-height: 1.9;}
.detail_hide .detail_label .label_line .tabs_wrap .tab_lv3.active{color: #e4393c;text-decoration: underline;}
.label_line .tab_lv2 .lv2:hover ,.label_line .tabs_wrap .tab_lv3:hover{color: #e4393c;text-decoration: underline;}
.top_section .center_main{width: 600px;display: flex;flex-direction: column;justify-content: space-between;}
.center_main .swiper_wrap{width: 100%;height: 256px;}
.center_main .swiper_wrap .swiper{height: 100%;}
.center_main .swiper_wrap .swiper_btn{width: 26px;height: 50px;background: rgba(0, 0, 0, .4);display: flex;justify-content: center;align-items: center;cursor: pointer;position: absolute;top: 50%;transform: translateY(-50%);z-index: 22;}
.center_main .swiper_wrap .swiper_btn.prev{left: 0;}
.center_main .swiper_wrap .swiper_btn.next{right: 0;}
.center_main .swiper_wrap .swiper_btn .icon-fanhui{font-size: 20px;color: #ffffff;}
.center_main .swiper_wrap .swiper_btn:hover .icon-fanhui{color: #fa5757;}
.center_main .swiper_wrap .swiper_btn.next .icon-fanhui{transform: rotate(180deg);}
.center_main .adx_box{width: 100%;height: 112px;display: block;}
.top_section .right_con{width: 348px;display: flex;flex-direction: column;background: #fff;position: relative;}
.right_con .supplier_login_btn{position: absolute;right: 16px;top: 18px;font-size: 14px;color: #999 !important;}
.right_con .supplier_login_btn:hover{color: var(--red) !important;}
.right_con .user_wrap{padding: 28px 16px 26px;background: #faedee;}
.right_con .user_wrap .user_con{display: flex;align-items: center;}
.right_con .user_wrap .user_con .head_box{width: 54px;height: 54px;background: #ffffff;border-radius: 50%;display: flex;justify-content: center;align-items: center;position: relative;}
.right_con .user_wrap .user_con .head_box .iconfont{font-size: 34px;color: #fdaeae;}
.right_con .user_wrap .user_con .head_box .head{width: 100%;height: 100%;object-fit: cover;border-radius: 50%;}
.right_con .user_wrap .user_con .con{flex: 1;width: 0;margin-left: 15px;font-size: 14px;line-height: 1;}
.right_con .user_wrap .user_con .con .txt{margin-top: 8px;color: #999;}
.right_con .user_wrap .btn_wrap{margin-top: 18px;display: flex;justify-content: space-between;}
.right_con .user_wrap .btn_wrap .btn{width: 152px;height: 32px;box-sizing: border-box;border-radius: 5em;display: flex;justify-content: center;align-items: center;font-size: 14px;cursor: pointer;}
.right_con .user_wrap .btn_wrap .btn:nth-child(1){background: #fa5757;color: #ffffff;}
.right_con .user_wrap .btn_wrap .btn:nth-child(2){background: #fff;color: #fa5757;border: 1px solid #fa5757;}
.right_con .order_nums{width: 100%;height: 88px;border-bottom: 1px solid #eeeeee;display: flex;align-items: center;}
.right_con .order_nums .num_box{flex: 1;text-align: center;line-height: 1;cursor: pointer;}
.right_con .order_nums .num_box .num{font-size: 20px;}
.right_con .order_nums .num_box .txt{font-size: 14px;color: #666666;margin-top: 10px;}
.right_con .news_wrap{flex: 1;height: 0;padding: 18px 16px 16px;position: relative;}
.right_con .news_wrap .jiaoliu{display: flex;position: absolute;right: 10px;top: 18px;cursor: pointer;}
.right_con .news_wrap .jiaoliu img{width: 20px;height: 20px;}
.right_con .news_wrap .jiaoliu .text{font-size: 14px;color: #1c6cd6;margin-left: 5px;}
.right_con .news_wrap .news_img{width: 73px;height: 18px;margin-bottom: 4px;}
.right_con .news_wrap .news_link{margin-top: 8px;cursor: pointer;display: flex;justify-content: space-between;align-items: center;}
.right_con .news_wrap .news_link .title{font-size: 14px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;display: inline-block;color: #333333;line-height: 1;cursor: pointer;width: 75%;}
.right_con .news_wrap .news_link .time{font-size: 14px;display: inline-block;color: #999;}
.right_con .news_wrap .news_link:hover{color: #fa5757;text-decoration: underline;}
.product_section{width: 100%;height: auto;box-sizing: border-box;background: #fff;margin-top: 20px;padding: 0 20px 20px;}
.product_section .screen_wrap{width: 100%;height: 47px;border-bottom: 1px solid #eeeeee;display: flex;align-items: center;}
.screen_wrap .title{font-weight: bold;margin-right: 60px;}
.screen_wrap .tab{font-size: 14px;margin-right: 40px;display: flex;align-items: center;cursor: pointer;}
.screen_wrap .tab:hover{color: var(--red);text-decoration: underline;}
.screen_wrap .tab.active{color: #fa5757;}
.screen_wrap .in_box{width: 54px;height: 24px;border: 1px solid #ccc;box-sizing: border-box;padding: 0 6px;display: flex;align-items: center;font-size: 14px;color: #999;}
.screen_wrap .in_box .in{margin-left: 6px;}
.screen_wrap .in_line{width: 20px;display: flex;justify-content: center;align-items: center;color: #999999;}
.screen_wrap .in_btn{margin-left: 12px;width: auto;padding:0 10px;height: 26px;background: #ddd;display: flex;justify-content: center;align-items: center;cursor: pointer;font-size: 12px;color: #666666;}
.el_input{margin: 14px auto 0 !important;width: 100%;}
</style>
<style>
.el_input.el_in2 .el-input__prefix{top: 0;left: 0;}
.el_input{display: flex;margin-top: 14px;}
.el_input .el-input__inner{height: 38px;line-height: 38px;padding-left: 58px;flex: 1;width: 0;}
.el_input .el-input__inner:focus{border-color: var(--red);}
.el_input.el_in2 .el-input__inner{padding-left: 90px;}
.account_login .el_input .el-input__prefix{left: 1px;top: 1px;height: 36px;}
.el_input .el-input__prefix .icons{width: 38px;height: 36px;display: flex;justify-content: center;align-items: center;top: 1px;left: 2px;background: #f5f5f5;border-right: 1px solid #ddd;border-radius: 4px 0 0 4px;}
.el_input .el-input__prefix .icons .iconfont{font-size: 20px;color: #cccccc;}
.el_input .el-input__prefix .txts{width: 100%;height: 100%;display: flex;align-items: center;padding-left: 10px;}
.el_input .el-input__suffix{display: flex;}
.el_input .el-input__suffix .el-input__suffix-inner{display: flex;align-items: center;}
.el_input .el-input__suffix .el-input__suffix-inner .getcode{font-size: 14px;color: #333333;padding: 0 12px;border-left: 1px solid #ccc;line-height: 1;cursor: pointer;}
.register_main .check_line .el-checkbox{margin-right: 8px;margin-top: 2px;}
.el-checkbox__input.is-focus .el-checkbox__inner{border-color: #DCDFE6 !important;}
.el-checkbox__input.is-checked .el-checkbox__inner{background-color: #fb5758 !important;border-color: #fb5758 !important;}
.el-dropdown-menu__item:focus, .el-dropdown-menu__item:not(.is-disabled):hover{background-color: #ffedee;color: #fa5757;}
</style>
